// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $$String = require("bs-platform/lib/js/string.js");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Pin$XodProject = require("./Pin.bs.js");
var Link$XodProject = require("./Link.bs.js");
var Node$XodProject = require("./Node.bs.js");
var Patch$XodProject = require("./Patch.bs.js");
var Project$XodProject = require("./Project.bs.js");
var PatchPath$XodProject = require("./PatchPath.bs.js");

function isCompositionPatch(patch) {
  if (!Patch$XodProject.isNotImplementedInXod(patch) && !Patch$XodProject.isTerminal(patch) && !Patch$XodProject.isRecord(patch)) {
    return !Patch$XodProject.isUnpackRecord(patch);
  } else {
    return false;
  }
}

function getUpstreamPinWithOwnerNodeFromInputPin(pin, node, currentPatch, project) {
  var pinKey = Pin$XodProject.getKey(pin);
  var nodeId = Node$XodProject.getId(node);
  return Belt_Option.flatMap(Belt_List.head(Belt_List.keep(Patch$XodProject.listLinks(currentPatch), (function (link) {
                        if (Link$XodProject.getInputPinKey(link) === pinKey) {
                          return Link$XodProject.getInputNodeId(link) === nodeId;
                        } else {
                          return false;
                        }
                      }))), (function (link) {
                var upstreamPinKey = Link$XodProject.getOutputPinKey(link);
                var upstreamNode = Patch$XodProject.getNodeById(currentPatch, Link$XodProject.getOutputNodeId(link));
                var upstreamPin = Belt_Option.flatMap(Belt_Option.flatMap(upstreamNode, (function (param) {
                            return Project$XodProject.getPatchByNode(project, param);
                          })), (function (patch) {
                        return Patch$XodProject.getPinByKey(patch, upstreamPinKey);
                      }));
                if (upstreamPin !== undefined && upstreamNode !== undefined) {
                  return /* tuple */[
                          Caml_option.valFromOption(upstreamPin),
                          Caml_option.valFromOption(upstreamNode)
                        ];
                }
                
              }));
}

function getUpstreamBusInputPinWithOwnerNode(node, currentPatch, project) {
  var busLabel = Node$XodProject.getLabel(node);
  return Belt_Option.flatMap(Belt_List.head(Belt_List.keep(Patch$XodProject.listNodes(currentPatch), (function (node) {
                        if (Node$XodProject.getLabel(node) === busLabel) {
                          return PatchPath$XodProject.isToBus(Node$XodProject.getType(node));
                        } else {
                          return false;
                        }
                      }))), (function (toBusNode) {
                return Belt_Option.map(Belt_Option.flatMap(Project$XodProject.getPatchByNode(project, toBusNode), (function (patch) {
                                  return Belt_List.head(Patch$XodProject.listInputPins(patch));
                                })), (function (toBusInputPin) {
                              return /* tuple */[
                                      toBusInputPin,
                                      toBusNode
                                    ];
                            }));
              }));
}

function drillDownAndGetTerminalsInputPin(pin, patchToDrillDown, project) {
  var pinKey = Pin$XodProject.getKey(pin);
  var _terminalNode = Patch$XodProject.getNodeById(patchToDrillDown, pinKey);
  return Belt_Option.flatMap(_terminalNode, (function (terminalNode) {
                return Belt_Option.map(Belt_Option.flatMap(Project$XodProject.getPatchByPath(project, Node$XodProject.getType(terminalNode)), (function (terminalPatch) {
                                  return Belt_List.head(Patch$XodProject.listInputPins(terminalPatch));
                                })), (function (terminalInputPin) {
                              return /* tuple */[
                                      terminalInputPin,
                                      terminalNode
                                    ];
                            }));
              }));
}

function listOf(a) {
  return /* :: */[
          a,
          /* [] */0
        ];
}

function patchNodeIdWithParentNodeId(parentNodeId, param) {
  var node = param[1];
  var originalNodeId = Node$XodProject.getId(node);
  var newNodeId = $$String.concat("~", /* :: */[
        parentNodeId,
        /* :: */[
          originalNodeId,
          /* [] */0
        ]
      ]);
  var patchedNode = Node$XodProject.setId(newNodeId, node);
  return /* tuple */[
          param[0],
          patchedNode
        ];
}

function listUpstreamPinsToNiix(pinPairs, currentPatch, project) {
  return Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.flatMap(Belt_List.head(pinPairs), (function (param) {
                        var node = param[1];
                        var pin = param[0];
                        var match = Pin$XodProject.getDirection(pin);
                        var match$1 = Project$XodProject.getPatchByNode(project, node);
                        if (match) {
                          if (match$1 !== undefined) {
                            var patch = Caml_option.valFromOption(match$1);
                            if (Patch$XodProject.isFromBus(patch)) {
                              return Belt_Option.map(getUpstreamBusInputPinWithOwnerNode(node, currentPatch, project), listOf);
                            } else if (Patch$XodProject.isAbstract(patch) || !isCompositionPatch(patch)) {
                              return ;
                            } else {
                              return Belt_Option.flatMap(drillDownAndGetTerminalsInputPin(pin, patch, project), (function (terminalPair) {
                                            var insidePairs = listUpstreamPinsToNiix(/* :: */[
                                                  terminalPair,
                                                  /* [] */0
                                                ], patch, project);
                                            if (insidePairs) {
                                              var insideLatestNode = insidePairs[0][1];
                                              if (PatchPath$XodProject.isTerminal(Node$XodProject.getType(insideLatestNode))) {
                                                var inputTerminalPinKey = Node$XodProject.getId(insideLatestNode);
                                                var parentNodeId = Node$XodProject.getId(node);
                                                return Belt_Option.map(Patch$XodProject.getPinByKey(patch, inputTerminalPinKey), (function (inputNodePin) {
                                                              return Belt_List.add(Belt_List.map(insidePairs, (function (param) {
                                                                                return patchNodeIdWithParentNodeId(parentNodeId, param);
                                                                              })), /* tuple */[
                                                                          inputNodePin,
                                                                          node
                                                                        ]);
                                                            }));
                                              } else {
                                                var parentNodeId$1 = Node$XodProject.getId(node);
                                                return Belt_List.map(insidePairs, (function (param) {
                                                              return patchNodeIdWithParentNodeId(parentNodeId$1, param);
                                                            }));
                                              }
                                            }
                                            
                                          }));
                            }
                          } else {
                            return ;
                          }
                        } else {
                          return Belt_Option.map(getUpstreamPinWithOwnerNodeFromInputPin(pin, node, currentPatch, project), listOf);
                        }
                      })), (function (newPairs) {
                    return listUpstreamPinsToNiix(Belt_List.concat(newPairs, pinPairs), currentPatch, project);
                  })), pinPairs);
}

exports.listUpstreamPinsToNiix = listUpstreamPinsToNiix;
/* Pin-XodProject Not a pure module */



// WEBPACK FOOTER //
// ../src/Traversing.bs.js